import { render, staticRenderFns } from "./FaceCapture.vue?vue&type=template&id=477972d2"
import script from "./FaceCapture.vue?vue&type=script&lang=js"
export * from "./FaceCapture.vue?vue&type=script&lang=js"
import style0 from "./FaceCapture.vue?vue&type=style&index=0&id=477972d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports